/**
 * Identity — anonymous local-only player identity.
 *
 * Per SPEC.md §1, there are no accounts. We store a display name and a hat
 * color in localStorage. The user picks both on the splash screen.
 */

const KEY = 'virtuaroo:identity';

export interface Identity {
  displayName: string;
  hatColor: number; // 0..7 index into a palette
}

const DEFAULT_NAMES = [
  'TieDyeT',
  'DanceTrucker',
  'WhatStager',
  'CenterooKid',
  'WhichDoctor',
  'GroovyGoose',
  'TentTorch',
  'MoonHowler'
];

export function loadIdentity(): Identity {
  try {
    const raw = localStorage.getItem(KEY);
    if (raw) {
      const parsed = JSON.parse(raw) as Partial<Identity>;
      if (parsed.displayName && typeof parsed.hatColor === 'number') {
        return { displayName: parsed.displayName, hatColor: parsed.hatColor };
      }
    }
  } catch {
    // localStorage may be disabled in private mode; fall through to default.
  }
  return {
    displayName: DEFAULT_NAMES[Math.floor(Math.random() * DEFAULT_NAMES.length)],
    hatColor: Math.floor(Math.random() * 8)
  };
}

export function saveIdentity(id: Identity): void {
  try {
    localStorage.setItem(KEY, JSON.stringify(id));
  } catch {
    // ignore
  }
}
